const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DataTrackingPopup/DataTrackingPopup.tsx';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import textMap from './translations';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { TrackingState } from 'App/defs/trackingDefs';
import { ACTION_TYPE_PATAPP_TRACKING_AGREE, ACTION_TYPE_PATAPP_TRACKING_DISAGREE } from 'App/actions/tracking';
import { trackingSelector } from 'App/store/tracking';

// FIXME: remove styled(...)
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const PopupTitle = (props: any) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

export default function DataTrackingPopup() {
    const [open, setOpen] = useState(false);
    const { formatMessage } = useIntl();
    const tracking = useSelector(trackingSelector);
    const dispatch = useDispatch();

    const handleClose = (action: any) => {
        dispatch({ type: action });
        setOpen(false);
    };

    useEffect(() => {
        setOpen(
            (tracking as any) === TrackingState.INITIAL || (tracking as any) === TrackingState.NO_PERMISSION_AVAILABLE
        );
    }, [tracking]);

    return (
        <div>
            <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <PopupTitle onClose={handleClose}>{formatMessage(textMap.dialogTitle)}</PopupTitle>
                <DialogContent>
                    <Typography gutterBottom>{formatMessage(textMap.dialogMessageDetail)}</Typography>
                    <Typography gutterBottom>{formatMessage(textMap.dialogQuestion)}</Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'start' }}>
                    <Button
                        onClick={() => handleClose(ACTION_TYPE_PATAPP_TRACKING_AGREE)}
                        color="primary"
                        variant="contained"
                    >
                        {formatMessage(textMap.dialogAgree)}
                    </Button>
                    <Button onClick={() => handleClose(ACTION_TYPE_PATAPP_TRACKING_DISAGREE)}>
                        {formatMessage(textMap.dialogDisagree)}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
